import { RestfulService } from "./restful.service";

class OperatorApiService extends RestfulService {
  //lobby
  public async doGetInitDataForLobby(request: any): Promise<any> {
    const response = await this.doGet("/lobby/getInitData", {
      monitor_console_id: request.monitorConsoleId,
    });
    return response;
  }

  public async doGetAllRefreshDataForLobby(request: any): Promise<any> {
    const response = await this.doGet("/lobby/getAllRefreshData", {
      vccs: request.vehicleCommunicationCodes,
      base_id: request.baseId,
      monitor_console_id: request.monitorConsoleId,
    });

    return response;
  }

  public async doGetBasePoint(request: any): Promise<any> {
    const response = await this.doGet("/lobby/getBasePoint", {
      base_id: request.baseId,
    });

    return response;
  }

  public async doGetMapPoints(request: any): Promise<any> {
    const response = await this.doGet("/lobby/getMapPoints", {
      base_id: request.baseId,
    });

    return response;
  }

  //observe
  public async doGetInitDataForObserve(request: any): Promise<any> {
    const response = await this.doGet("/observe/getInitData", {
      monitor_console_id: request.monitorConsoleId,
      base_id: request.baseId,
    });
    return response;
  }

  public async doGetAllRefreshDataForObserve(
    vehicleMonitorPairs: any,
  ): Promise<any> {
    const response = await this.doGet(
      "/observe/getAllRefreshData",
      vehicleMonitorPairs,
    );
    return response;
  }

  public async doGetFirstConfirmationRequest(vehicle_id: any): Promise<any> {
    const response = await this.doGet("/observe/getFirstConfirmationRequest", {
      vehicleId: vehicle_id,
    });
    return response;
  }

  public async doGetMessageModalInfo(request: any): Promise<any> {
    const response = await this.doGet("/observe/getMessageModalInfo", {
      vehicle_id: request.vehicleId,
      message_id: request.messageId,
    });
    return response;
  }

  //observe 永平寺
  public async doGetVehicleDlyInfo(request: any): Promise<any> {
    const response = await this.doGet("/observe/getVehicleDlyInfo", {
      monitor_console_id: request.monitorConsoleId,
    });
    return response;
  }

  //onevehicle
  public async doGetInitDataForOnevehicle(request: any): Promise<any> {
    const response = await this.doGet("/onevehicle/getInitData", {
      monitor_console_id: request.monitorConsoleId,
    });
    return response;
  }

  public async doGetOnevehicleLayoutCheck(request: any): Promise<any> {
    const response = await this.doGet("/onevehicle/layoutCheck", {
      monitor_console_id: request.monitorConsoleId,
    });
    return response;
  }

  public async doGetGuideLines(request: any): Promise<any> {
    const response = await this.doGet("/onevehicle/getGuideLines", {
      vehicle_id: request.selectingVehicleId,
      guide_pat: request.guide,
      video_pat: request.videoPat,
    });
    return response;
  }

  public async doPostLogForOnevehicle(request: any): Promise<any> {
    const response = await this.doPost("/onevehicle/oneVehiclelog", {
      data: request.data,
    });
    return response;
  }

  //fourvehicle
  public async doGetFourvehicleLayoutCheck(request: any): Promise<any> {
    const response = await this.doGet("/fourvehicle/layoutCheck", {
      monitor_console_id: request.monitorConsoleId,
    });
    return response;
  }

  // config
  public async doGetJanusConfig(request: any): Promise<any> {
    const response = await this.doGet("/config/getJanusConfig", {
      base_id: request.baseId,
    });
    return response;
  }

  public async doGetCommunicationCode(request: any): Promise<any> {
    const response = await this.doGet("/config/getCommunicationCode", {
      role_cd: request.role_cd,
      monitor_console_id: request.monitor_console_id,
    });
    return response;
  }

  // master system
  public async doGetBase(request: any): Promise<any> {
    const response = await this.doGet("/master/getBase", {
      base_id: request.baseId,
    });
    return response;
  }

  public async editBase(request: any): Promise<any> {
    const response = await this.doPost("/master/editBase", {
      base_id: request.base_id,
      base_name: request.base_name,
      zao_cloud_url: request.zao_cloud_url,
      credential: request.credential,
      map_latitude: request.map_latitude,
      map_longitude: request.map_longitude,
      map_zoom: request.map_zoom,
      monitor_error_cd: request.monitor_error_cd,
    });
    return response;
  }

  public async doGetMonitorConsoles(request: any): Promise<any> {
    const response = await this.doGet("/master/getMonitorConsoles", {
      base_id: request.baseId,
    });
    return response;
  }

  public async saveMonitorConsoles(request: any): Promise<any> {
    const response = await this.doPost("/master/saveMonitorConsoles", {
      base_id: request.baseId,
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetVehicles(request: any): Promise<any> {
    const response = await this.doGet("/master/getVehicles", {
      base_id: request.baseId,
    });
    return response;
  }

  public async saveVehicles(request: any): Promise<any> {
    const response = await this.doPost("/master/saveVehicles", {
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetFourVehicleLayout(request: any): Promise<any> {
    const response = await this.doGet("/master/getFourVehicleLayout", {
      base_id: request.baseId,
    });
    return response;
  }

  public async doGetMonitorVehiclesByConsoleNo(request: any): Promise<any> {
    return await this.doPost("/master/getMonitorVehiclesByConsoleNo", {
      base_id: request.baseId,
      monitor_console_no: request.monitorConsoleNo,
    });
  }

  public async saveFourVehicleLayout(request: any): Promise<any> {
    const response = await this.doPost("/master/saveFourVehicleLayout", {
      monitor_console_no: request.monitor_console_no,
      base_id: request.base_id,
      postdata: request.postdata,
      monitorVehicles: request.monitorVehicles,
    });
    return response;
  }

  // master user
  public async doGetUsers(request: any) {
    const response = await this.doGet("/master/getUsers", {
      user_name: request.searchUserName,
    });
    return response;
  }

  public async createUser(request: any): Promise<any> {
    const response = await this.doPost("/master/createUser", {
      role_cd: request.role_cd,
      monitor_console_id: request.monitor_console_id,
      user_name: request.user_name,
      communication_code: request.communication_code,
      password: request.password,
    });
    return response;
  }

  public async editUser(request: any): Promise<any> {
    const response = await this.doPost("/master/editUser", {
      user_id: request.user_id,
      role_cd: request.role_cd,
      monitor_console_id: request.monitor_console_id,
      user_name: request.user_name,
      communication_code: request.communication_code,
      password: request.password,
    });
    return response;
  }

  public async deleteUser(userId: number): Promise<any> {
    return await this.doPost("/master/deleteUser", { user_id: userId });
  }

  // master
  public async doGetRoles() {
    const response = await this.doGet("/master/getRoles");
    return response;
  }

  public async saveRoles(request: any): Promise<any> {
    const response = await this.doPost("/master/saveRoles", {
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetVehicleModels(request: any): Promise<any> {
    const response = await this.doGet("/master/getVehicleModels", {
      base_id: request.baseId,
    });
    return response;
  }

  public async saveVehicleModels(request: any): Promise<any> {
    const response = await this.doPost("/master/saveVehicleModels", {
      base_id: request.baseId,
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetAnnouncements(request: any): Promise<any> {
    const response = await this.doGet("/master/getAnnouncements", {
      base_id: request.baseId,
    });
    return response;
  }

  public async saveAnnouncements(request: any): Promise<any> {
    const response = await this.doPost("/master/saveAnnouncements", {
      base_id: request.baseId,
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetRequestClasses(request: any): Promise<any> {
    const response = await this.doGet("/master/getRequestClasses", {
      base_id: request.baseId,
    });
    return response;
  }

  public async saveRequestClasses(request: any): Promise<any> {
    const response = await this.doPost("/master/saveRequestClasses", {
      base_id: request.baseId,
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetScreenMessages(): Promise<any> {
    const response = await this.doGet("/master/getScreenMessages");
    return response;
  }

  public async saveScreenMessages(request: any): Promise<any> {
    const response = await this.doPost("/master/saveScreenMessages", {
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }

  public async doGetBaseStops(request: any): Promise<any> {
    const response = await this.doGet("/master/getBaseStops", {
      base_id: request.baseId,
    });
    return response;
  }

  public async doGetBpsLogData(request: any): Promise<any> {
    const response = await this.doGet(
      "/bpslog/getData",
      {
        vehicle_id: request.vehicleId,
        start: request.start,
        end: request.end,
        after_id: request.afterId,
        max_rows: request.maxRows,
        delay_offset_ms: request.delayOffsetMs,
        no_cap: request.noCap,
      },
      request?.signal ? { signal: request.signal } : undefined,
    );
    return response;
  }

  public getDownloadBpsLogCsvUrl(request: {
    vehicleId: number;
    start: string;
    end: string;
    delayOffsetMs?: number;
  }): string {
    const base = String(import.meta.env.VITE_API_URL || "").replace(/\/$/, "");
    const params = new URLSearchParams({
      vehicle_id: String(request.vehicleId),
      start: request.start,
      end: request.end,
    });

    if (
      typeof request.delayOffsetMs === "number" &&
      Number.isFinite(request.delayOffsetMs)
    ) {
      params.set("delay_offset_ms", String(request.delayOffsetMs));
    }

    return `${base}/bpslog/download?${params.toString()}`;
  }

  public async saveBaseStops(request: any): Promise<any> {
    const response = await this.doPost("/master/saveBaseStops", {
      base_id: request.baseId,
      create: request.create,
      update: request.update,
      delete: request.delete,
    });
    return response;
  }
}

export const operatorApiService = new OperatorApiService();
export default operatorApiService;
